<template>
<main-content>
    <kt-panel>
        <kt-panel-header>
            <kt-panel-header-toolbar>
                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" data-toggle="tab" href="#user-info" role="tab" aria-selected="false">
                            {{ $t('label.user-info') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#shaparak-info" role="tab" aria-selected="false">
                            {{ $t('label.shaparak-info') }}
                        </a>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true">
                            {{ $t('label.support') }}
                        </a>
                        <div class="dropdown-menu dropdown-menu-right" x-placement="bottom-end">
                            <a class="dropdown-item" data-toggle="tab" href="#new-ticket">{{ $t('label.new_ticket') }}</a>
                            <a class="dropdown-item" data-toggle="tab" href="#tickets">{{ $t('label.tickets') }}</a>
                        </div>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true">
                            {{ $t('label.financial') }}
                        </a>
                        <div class="dropdown-menu dropdown-menu-right" x-placement="bottom-end">
                            <a class="dropdown-item" data-toggle="tab" href="#settlements">{{ $t('label.settlements') }}</a>
                            <a class="dropdown-item" data-toggle="tab" href="#gateways">{{ $t('label.gateways') }}</a>
                            <a class="dropdown-item" data-toggle="tab" href="#transactions">{{ $t('label.transactions') }}</a>
<!--                            <a class="dropdown-item" data-toggle="tab" href="#sheba-numbers">{{ $t('label.bank_accounts') }}</a>-->
                            <a class="dropdown-item" data-toggle="tab" href="#bank_accounts">{{ $t('label.bank_accounts') }}</a>
                        </div>
                    </li>
                    <li>
                        <kt-button v-if="current_user.id !== user_hashid"
                                class="m-2" size="md" variant="success" type="button"
                                id="submit_access_change_btn" @click="LoginToUserPanel"
                        >
                            {{ $t('btn.LoginToUserPanel') }}
                        </kt-button>
                    </li>
                    <!-- <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#login-as" role="tab">
                            {{ $t('label.login_as') }}
                        </a>
                    </li> -->
                </ul>
            </kt-panel-header-toolbar>
        </kt-panel-header>
        <kt-panel-body>
            <div class="tab-content">
                <div class="tab-pane active" id="user-info">
                    <kt-row>
                        <kt-col xs="12" md="6">
                            <user-info></user-info>
                        </kt-col>
                        <kt-col xs="12" md="6">
                            <user-statistics></user-statistics>
                            <user-profile></user-profile>
                        </kt-col>
                    </kt-row>
                </div>
                <div class="tab-pane" id="shaparak-info">
                    <shaparak-info></shaparak-info>
                </div>
                <div class="tab-pane" id="tickets">
                    <tickets v-if="active_pane === '#tickets'"></tickets>
                </div>
                <div class="tab-pane" id="new-ticket">
                    <new-ticket v-if="active_pane === '#new-ticket'"></new-ticket>
                </div>
                <div class="tab-pane" id="settlements">
                    <settlements v-if="active_pane === '#settlements'"></settlements>
                </div>
                <div class="tab-pane" id="gateways">
                    <gateways v-if="active_pane === '#gateways'"></gateways>
                </div>
                <div class="tab-pane" id="transactions">
                    <transactions v-if="active_pane === '#transactions'"></transactions>
                </div>
                <div class="tab-pane" id="bank_accounts">
                    <bank-accounts v-if="active_pane === '#bank_accounts'"></bank-accounts>
                </div>
                <!-- <div class="tab-pane" id="login-as">
                    <login-as></login-as>
                </div> -->
            </div>
            
        </kt-panel-body>
    </kt-panel>
</main-content>
</template>

<script>
import $ from 'jquery'
import { mapGetters } from 'vuex'
import mainContent from '@/components/main-content'
import userStatistics from './components/user-statistics'
import { getToken } from '@/common/jwt.service.js';

import {
    tickets,
    newTicket,
    userInfo,
    userProfile,
    settlements,
    shaparakInfo,
    transactions,
    bankAccounts,
    gateways,
    loginAs,
}  from './components'

export default {
    data() {
        return {
            active_pane: '#user-info',
            user_hashid: this.$route.params.hashid
        }
    },
    components: {
        mainContent,
        tickets,
        newTicket,
        userInfo,
        userProfile,
        settlements,
        shaparakInfo,
        transactions,
        bankAccounts,
        gateways,
        'user-statistics': userStatistics
        // loginAs,
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('user/fetchByHashId', vm.$route.params.hashid)
        })
    },
    mounted() {
        $('a[data-toggle="tab"]').on('show.bs.tab', (e) => {
            this.active_pane = $(e.target).attr("href")
        })
    },
    methods: {
        LoginToUserPanel() {
            let params = {
                'user_hashid': this.$route.params.hashid,
                'admin_hashid': this.current_user.id,
            }


            let token = getToken();
            window.localStorage.setItem('Admin_token', token);

            this.$store.dispatch('auth/adminLoginToUserPanel', params).then(
                response => {
                    window.location.replace(this.$url(''))
                }
            )

            window.localStorage.removeItem('wallet-selected')
        }
    },
    computed: {
        ...mapGetters('user', [
            'current_user'
        ])
    }
}
</script>

<style>
@media (min-width: 768px) {
    #user-info > div.row > :first-child {
        border-left: 1px solid #ddd;
    }
}
</style>